module.exports = __webpack_public_path__ + "static/demo-micro-sniff-e395cd36ade22eabb44a9176102665f8.mp4";